module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAcElEQVQ4je1SQQ6AIAxrjQ+Hp/GyemEqI7LFeLSXFsK6sgwAIAmSuoy5awDAZoKkJKHWumSSV7WhlKLeIs1TAvtKxK21oflg8Aa7vyA5JLLzfXBLA//wqTCVIGMUJojwJ/hykfyKZkHg3Lh0dkm0WR0B3pDX/1h3rAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/TEXTFILE_16.png
// module id = 106
// module chunks = 0